export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/b012a9771435469a84e4760bdedcd474.jpeg" 
                alt="Plymouth & Fortaleza Church"
                className="w-full h-[500px] object-cover object-top"
              />
              <div className="absolute top-6 left-6 flex flex-col gap-3">
                <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md">
                  <p className="text-sm font-semibold text-[#D2691E]">130 años de historia</p>
                </div>
                <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md">
                  <p className="text-sm font-semibold text-gray-800">Ambiente seguro</p>
                </div>
                <div className="bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-md">
                  <p className="text-sm font-semibold text-gray-800">Valores familiares</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2723] mb-6 leading-tight">
              Un Lugar Seguro en el que Puedes Confiar
            </h2>
            
            <div className="flex flex-wrap gap-3 mb-8">
              <span className="border-2 border-[#D2691E] text-[#D2691E] px-4 py-2 rounded-full text-sm font-semibold">
                Instalaciones certificadas
              </span>
              <span className="text-gray-600 px-4 py-2 text-sm">
                Ambiente familiar
              </span>
              <span className="text-gray-600 px-4 py-2 text-sm">
                Comunidad establecida
              </span>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Sabemos que dónde aprende tu hijo importa tanto como lo que aprende. Las clases se llevan a cabo en las instalaciones de Plymouth & Fortaleza Church, una institución con más de 130 años de presencia en la Ciudad de Whittier, profundamente arraigada en valores familiares, comunidad y confianza.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              Los padres pueden tener tranquilidad sabiendo que sus hijos están aprendiendo en un ambiente seguro, acogedor y con un propósito definido.
            </p>

            <div className="bg-[#3E2723] rounded-3xl p-8 shadow-xl">
              <div className="mb-4">
                <span className="text-[#D2691E] text-sm font-semibold uppercase tracking-wide">
                  Dirigido por
                </span>
              </div>
              
              <div className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-1">
                  <h3 className="text-3xl font-bold text-white mb-4">Emily Guerrero</h3>
                  <p className="text-gray-300 leading-relaxed">
                    Músico profesional y educadora musical con experiencia internacional. Emily lidera con excelencia y compasión, entiende a los niños, los desafía con gentileza y cree profundamente en ellos. Bajo su dirección, los estudiantes no son presionados, son guiados, alentados e inspirados a alcanzar su mejor versión.
                  </p>
                </div>
                
                <div className="w-full md:w-48 h-48 rounded-2xl overflow-hidden shadow-lg flex-shrink-0">
                  <img 
                    src="https://static.readdy.ai/image/1a62d479ea6bd5856073579187b5ee28/066f73cfd0114ae141bc535a03934d79.png" 
                    alt="Emily Guerrero"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
